module.exports = __webpack_public_path__ + "img/kolahduzan-logo.75730308.png";